import React, {} from 'react'
import {
  makeStyles,
} from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { useDispatch } from 'react-redux'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useFormInput } from '../../hooks/useFormInput'
import { addDiscountGroup } from '../../app/slices/discountSlice'

const useStyle = makeStyles(() => ({
  root: {
    // overflow: 'auto',
    borderRadius: '20px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#f9b233',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'red',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#f9b233',
      },
    },
    '.MuiMenuItem-root': {
      backgroundColor: '#f9b233',
    },

  },
  MuiPaper: {
    root: {
      MuiMenu: {
        paper: {
          borderRadius: '50px',

        },
      },

    },
  },
  inputs: {
    width: '100%',
  },
  MuiListItem: {
    root: {
      '&.Mui-selected:hover': {
        backgroundColor: '#f9b233',
      },
    },
  },
  selectRol: {
    // overflow: 'scroll',
    '& .MuiList-root': {
      borderRadius: '50px',
    },
  },
  menuItem: {
    // overflow: 'scroll',
    '&::selected': {
      backgroundColor: 'red',
    },
    '&:hover': {
      backgroundColor: '#fef6e7',
    },

  },
  myInput: {
    border: 'none',
    outline: 'none !important',
    '&:focus': {
      border: 'none',
      outline: 'none !important',
    },
  },
  focusInput: {
    color: '#000',
    outline: 'none !important',
  },
  list: {
    borderRadius: '5px',
    // top: '400px !important',
    bottom: '5px',
    border: '1px solid #f9b233',
    height: 'fit-content !important',
    // overflow: 'scroll !important',
    // padding: '20px 0',
    // display: 'flex',
    // flex: 1,
  },
  datePicker: {
    '& .MuiPickersDatePickerRoot-toolbar': {
      backgroundColor: 'orange !important',
    },
  },
  addBtn: {
    display: 'flex',
    justifyContent: 'end',
  },
  listRoot: {
    overflow: 'scroll !important',
    height: 'fit-content !important',
  },
}))

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const GroupForm = () => {
  const classes = useStyle()
  const dispatch = useDispatch()

  const name = useFormInput('')
  //   const code = useFormInput()
  //   const maxUsedCount = useFormInput(1)
  //   const packageNumber = useFormInput()
  //   const discountPercent = useFormInput()
  //   const maxDiscount = useFormInput()
  //   const count = useFormInput(1)

  const handleSubmit = (event) => {
    event.preventDefault()
    const data = {
      name: name.value,
    //   code: code.value,
    //   maxUsedCount: parseInt(maxUsedCount.value, 10),
    //   discountPercent: parseInt(discountPercent.value, 10),
    //   EntityType: parseInt(packageNumber.value, 10),
    //   MaxDiscountPrice: parseInt(maxDiscount.value, 10),
    }
    event.target.reset()
    dispatch(addDiscountGroup(data))
  }
  return (
    <form onSubmit={handleSubmit}>
      <Card className={classes.root}>
        <CardContent>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>

              <CssTextField
                fullWidth
                required
                type="text"
                variant="outlined"
                id="userName"
                {...name}
                label="نام گروه"
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid container item justify="flex-end" xs={12}>
              <Button type="submit" variant="contained" color="primary">ایجاد گروه جدید</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default GroupForm
